var _module = require('../components/module.js');

/*
formatPhoneNumber
Formats a 10 digit phone number
*/
_module.filter('formatPhoneNumber', function () {
    return function (phone) {
        return String(phone).replace(/([^0-9])/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
    };
});
